import { useCallback, useEffect, useRef, useState } from "react";

export default function useScrollTheme(isHome) {
  const [theme, setTheme] = useState("light");
  const currentSection = useRef(null);

  useEffect(() => {
    document.documentElement.dataset.theme = theme;
  }, [theme]);

  useEffect(() => {
    let frame = null;

    const update = () => {
      frame = null;
      let section = isHome ? "intro" : "blog";
      if (isHome) {
        // Follow the section entering the reading area, below the mobile nav.
        const readingLine = Math.max(window.innerHeight * 0.25, 140);
        for (const id of ["projects", "work-experience", "education"]) {
          const element = document.getElementById(id);
          if (element && element.getBoundingClientRect().top <= readingLine) section = id;
        }
      }

      // A manual choice lasts until the reader enters another section.
      if (section !== currentSection.current) {
        currentSection.current = section;
        setTheme(section === "projects" ? "dark" : "light");
      }
    };

    const scheduleUpdate = () => {
      if (frame === null) frame = window.requestAnimationFrame(update);
    };

    update();
    window.addEventListener("scroll", scheduleUpdate, { passive: true });
    window.addEventListener("resize", scheduleUpdate);
    const observer = typeof ResizeObserver !== "undefined" ? new ResizeObserver(scheduleUpdate) : null;
    if (isHome) observer?.observe(document.querySelector(".site-content"));
    return () => {
      window.removeEventListener("scroll", scheduleUpdate);
      window.removeEventListener("resize", scheduleUpdate);
      observer?.disconnect();
      if (frame !== null) window.cancelAnimationFrame(frame);
    };
  }, [isHome]);

  const toggleTheme = useCallback(() => setTheme(value => value === "dark" ? "light" : "dark"), []);
  return { theme, toggleTheme };
}
